let repairMatrixCols = [
    {
        key: 'id',
        display: 'Id'
    },
    {
        key: 'deviceDamageLinkId',
        display: 'Device Damage Link Id'
    },
    {
        key: 'deviceTypeId',
        display: 'Device Type Id'
    },
    {
        key: 'deviceTypeLabel',
        display: 'Device Type Label'
    },
    {
        key: 'makeId',
        display: 'Make Id'
    },
    {
        key: 'makeLabel',
        display: 'Make Label'
    },
    {
        key: 'modelId',
        display: 'Model Id'
    },
    {
        key: 'modelLabel',
        display: 'Model Label'
    },
    {
        key: 'incidentTypeId',
        display: 'Incident Type Id'
    },
    {
        key: 'incidentTypeLabel',
        display: 'Incident Type Label'
    },
    {
        key: 'repairProviderId',
        display: 'Repair Provider Id'
    },
    {
        key: 'repairProviderLabel',
        display: 'Repair Provider Label'
    },
    {
        key: 'providerWeighting',
        display: 'Provider Weighting'
    },
    {
        key: 'repairOptionTypeId',
        display: 'Repair Option Type Id'
    },
    {
        key: 'repairOptionTypeLabel',
        display: 'Repair Option Type Label'
    },
    {
        key: 'requireUpload',
        display: 'Require Upload'
    },
    {
        key: 'requireBooking',
        display: 'Require Booking'
    },
    {
        key: 'enabled',
        display: 'Enabled'
    }

]

export { repairMatrixCols }